import type { IconProps } from './base';
import { BaseIcon } from './base';

export function IconFlagSVSmall(props: IconProps) {
  return (
    <BaseIcon {...props} size={props.size ?? 16} viewBox="0 0 16 16">
      <mask id="icon-flag-sv-small" maskUnits="userSpaceOnUse" x="2" y="2" width="12" height="12">
        <rect x="2" y="2" width="12" height="12" rx="2" fill="#C4C4C4" />
      </mask>
      <g mask="url(#icon-flag-sv-small)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.89543 16 0 15.1046 0 14V2Z"
          fill="#005293"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.875 6.875V2H9.125V6.875H14V9.125H9.125V14H6.875V9.125H2V6.875H6.875Z"
          fill="#FECC02"
        />
        <rect x="2.5" y="2.5" width="11" height="11" stroke="#3C3C60" strokeOpacity="0.1" />
      </g>
    </BaseIcon>
  );
}
